export enum IseePaywallTestVariant {
  CONTROL = "control",
  SIMPLIFAID = "simplifaid",
  NONE = "none",
}
